import { CurrencyCodeType } from '@/types/currency';
import { StatusType, TransactionResponse } from '@/types/transaction';

export const emptyTransactionResponse: TransactionResponse = {
  id: '',
  from: {
    value: '0',
    currencyCode: CurrencyCodeType.UNSET,
  },
  to: {
    value: '0',
    currencyCode: CurrencyCodeType.UNSET,
  },
  localInfo: {
    pixCopyAndPaste: '',
    pixExpiresAt: '',
  },
  status: StatusType.PENDING,
  simulationId: '',
  integratorId: '',
  beneficiaryId: '',
  blockchainInfo: {
    depositTransactionHash: null,
    fundingWallet: '',
    targetWallet: null,
    withdrawalTransactionHash: null,
  },
  beneficiaryIp: '',
  flowOfFundsId: '',
  transactionDetails: {
    transferPurpose: null,
    paymentReference: null,
    memo: null,
    feeDetails: {
      taxes: {
        value: 0,
        currencyCode: CurrencyCodeType.UNSET,
      },
      totalFees: {
        value: 0,
        currencyCode: CurrencyCodeType.UNSET,
      },
      integratorFee: {
        value: null,
        currencyCode: CurrencyCodeType.UNSET,
      },
      fixedFees: [],
      oldFees: [],
      percentageFees: [],
      spreadFees: [],
      vet: '0.0000',
    },
    expectedSettlementTimeDetails: null,
  },
  createdDate: '',
  lastModifiedDate: '',
  payorId: null,
  efx: false,
};
